exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ProviderSearchBar-content-884ZP{min-height:475px}.ProviderSearchBar-tabTitle-1xljA span{display:none}@media (min-width:768px){.ProviderSearchBar-tabTitle-1xljA span{display:inline-block}}@media (min-width:768px){.ProviderSearchBar-tabTitle-1xljA i{display:none}}.ProviderSearchBar-footer-3DhAF h4 small{margin-left:20px;font-size:100%}", ""]);

// exports
exports.locals = {
	"content": "ProviderSearchBar-content-884ZP",
	"tabTitle": "ProviderSearchBar-tabTitle-1xljA",
	"footer": "ProviderSearchBar-footer-3DhAF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/ProviderSearchBar.less
// module id = 1723
// module chunks = 0